import { useCallback, useEffect, useMemo } from "react"
import { useLocation } from "react-router-dom"
import { Stepper } from "../../../components/Stepper"
import { Code, Phone, Telegram, User, Call } from "./screens"
import { AuthData } from "../../../types/steps/auth"
import { appStore } from "../../../store/appStore"
import { loadAuthDraft, saveAuthDraft } from "../../../lib/authDraft"

import { useAuthModalClose } from "../../../features/auth/useAuthModalClose"

export default function Auth() {
    const location = useLocation()
    const closeAuthModal = useAuthModalClose()
    const reauth = Boolean((location.state as { reauth?: boolean })?.reauth)
    const setReauthActive = appStore(s => s.setReauthActive)

    const savedDraft = useMemo(() => loadAuthDraft(), [])

    const modalBackground = useMemo(() => {
        const bg = (location.state as { backgroundLocation?: { pathname: string; search: string; hash: string } })
            ?.backgroundLocation
        if (bg) {
            return { pathname: bg.pathname, search: bg.search, hash: bg.hash }
        }
        return savedDraft?.modalBackground
    }, [location.state, savedDraft?.modalBackground])

    const initialStack = savedDraft?.stack
    const initialData = useMemo(
        () => ({ ...(savedDraft?.data ?? {}), reauth: savedDraft?.data?.reauth ?? reauth }),
        [savedDraft?.data, reauth],
    )

    useEffect(() => {
        if (reauth) setReauthActive(true)
        return () => setReauthActive(false)
    }, [reauth, setReauthActive])

    const handleStateChange = useCallback(
        (state: { stack: string[]; data: AuthData }) => {
            const current = loadAuthDraft()
            saveAuthDraft({
                stack: state.stack,
                data: state.data,
                userForm: current?.userForm,
                modalBackground,
            })
        },
        [modalBackground],
    )

    const steps = [
        { id: "phone", title: "Войти", component: Phone, selfHeader: true },
        { id: "code", title: "Код из СМС", component: Code, selfHeader: true },
        { id: "telegram", title: "Telegram", component: Telegram, selfHeader: true },
        { id: "user", title: "Регистрация", component: User, selfHeader: true },
        { id: "call", title: "Вход звонком", component: Call, selfHeader: true },
    ]

    return (
        <Stepper<AuthData>
            steps={steps}
            sheet
            compact
            initialStack={initialStack}
            initialData={initialData}
            onStateChange={handleStateChange}
            onDismiss={closeAuthModal}
        />
    )
}
